import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import { setBackgroundColor } from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'BACKGROUND_COLOR_CHANGE':
      return setBackgroundColor(state, action.payload);
    default:
      return state;
  }
}
